import * as React from "react";
import { isLearningCoachApplicationAccessible } from "../../../../helpers/LearningCoachApplicationHelper";
import { isStudentFollowSummaryAccessible } from "../../../../helpers/StudentFollowSummaryHelper";
import { OperatorPrivilege } from "../../../../interfaces/OperatorInterface";
import SectionInterface from "../../../../interfaces/SectionInterface";
import SidebarFooter from "../../../atoms/SidebarFooter/index";
import SidebarLayout from "../../../atoms/SidebarLayout/index";
import VisibleOnMobile from "../../../atoms/VisibleOnMobile/index";
import NaviMenuList from "../NaviMenuList/index";
import NaviMenuListItem from "../NaviMenuListItem/index";
import NaviMenuLogo from "../NaviMenuLogo/index";
import NaviMenuSchool from "../NaviMenuSchool/index";
import NaviMenuSPLogo from "../NaviMenuSPLogo/index";
import NaviMenuToggleButton from "../NaviMenuToggleButton/index";

interface Props {
  section: SectionInterface;
  activeMenu: string;
  opened: boolean;
  // 操作者の privileges。未読み込みの間は undefined
  privileges?: OperatorPrivilege[];
}

export default class SchoolNavi extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <SidebarLayout opened={this.props.opened} scrollable={false}>
          <NaviMenuLogo
            opened={this.props.opened}
            section={this.props.section}
          />
          <NaviMenuSPLogo
            opened={this.props.opened}
            section={this.props.section}
          />
          <NaviMenuList>
            <NaviMenuSchool
              opened={this.props.opened}
              section={this.props.section}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "dashboard"}
              label="ダッシュボード"
              iconName="icon-dashboard"
              link={`/sections/${this.props.section.id}`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "message"}
              label="メッセージ"
              iconName="icon-message"
              link={`/sections/${this.props.section.id}/message_threads`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "timeline"}
              label="タイムライン"
              iconName="icon-timeline"
              link={`/sections/${this.props.section.id}/timeline/daily`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "analytics"}
              label="アナリティクス"
              iconName="icon-analytics"
              link={`/sections/${this.props.section.id}/analytics/time`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "schedule_list"}
              label="カレンダー"
              iconName="icon-calendar"
              link={`/sections/${this.props.section.id}/schedules/list`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "study_schedules"}
              label="プランニング"
              iconName="icon-planning"
              link={`/sections/${this.props.section.id}/study_schedules`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "karte"}
              label="カルテ"
              iconName="icon-karte"
              link={`/sections/${this.props.section.id}/kartes`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={false}
              label="デジタル教材"
              iconName="icon-textbook"
              link={`/sections/${this.props.section.id}/settings/digital_learning_materials`}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "student_follow_summary"}
              label="AIアシスタントサマリー"
              iconName="icon-ai-assistant"
              link={`/sections/${this.props.section.id}/student_follow_summaries`}
              visible={isStudentFollowSummaryAccessible(this.props.section)}
            />
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "learning_coach"}
              label="学習コーチング"
              iconName="icon-learning-coach"
              link={`/sections/${this.props.section.id}/learning_coach/application_requests`}
              visible={isLearningCoachApplicationAccessible(
                this.props.section,
                this.props.privileges,
              )}
            />
            <VisibleOnMobile>
              <NaviMenuListItem
                opened={this.props.opened}
                isActive={this.props.activeMenu === "setting"}
                label="設定"
                iconName="icon-setting"
                link={`/sections/${this.props.section.id}/settings/students`}
              />
            </VisibleOnMobile>
          </NaviMenuList>
          <SidebarFooter opened={this.props.opened}>
            <NaviMenuListItem
              opened={this.props.opened}
              isActive={this.props.activeMenu === "setting"}
              label="設定"
              iconName="icon-setting"
              link={`/sections/${this.props.section.id}/settings/students`}
            />
            <NaviMenuToggleButton />
          </SidebarFooter>
        </SidebarLayout>
      </React.Fragment>
    );
  }
}
